(function () {
  const styleId = 'sukker-corporate-forms-shadow-style';
  const termsUrl = '/pages/promotions';

  const shadowStyles = `
    :host {
      --inline-container-max-width: 600px !important;
      --heading-font-size: 32px !important;
      --forms-base-font-size: 16px !important;
      --forms-heading-font: normal 700 32px DM Sans, sans-serif !important;
      --forms-body-font: normal 400 16px DM Sans, sans-serif !important;
    }

    [class*="_formContainer_"] {
      max-width: 600px !important;
    }

    h2,
    [class*="_textHeading_"],
    [class*="_formTitle_"],
    [class*="_heading_"],
    [class*="_title_"] {
      font-size: 32px !important;
      line-height: 1.1 !important;
      font-weight: 700 !important;
    }

    [class*="_textBody_"],
    [class*="_textBody_"] p,
    [class*="_description_"],
    [class*="_description_"] p {
      font-size: 16px !important;
      line-height: 1.5 !important;
    }

    .sukker-terms-link {
      color: inherit !important;
      text-decoration: underline !important;
      text-underline-offset: 0.15em !important;
    }

    .sukker-terms-link:hover,
    .sukker-terms-link:focus {
      color: inherit !important;
    }

    @media screen and (max-width: 749px) {
      :host {
        --heading-font-size: 30px !important;
        --forms-base-font-size: 15px !important;
        --forms-heading-font: normal 700 30px DM Sans, sans-serif !important;
        --forms-body-font: normal 400 15px DM Sans, sans-serif !important;
      }

      h2,
      [class*="_textHeading_"],
      [class*="_formTitle_"],
      [class*="_heading_"],
      [class*="_title_"] {
        font-size: 30px !important;
      }

      [class*="_textBody_"],
      [class*="_textBody_"] p,
      [class*="_description_"],
      [class*="_description_"] p {
        font-size: 15px !important;
      }
    }
  `;

  function setHostVariables(embed) {
    embed.style.setProperty('--inline-container-max-width', '600px', 'important');
    embed.style.setProperty('--heading-font-size', '32px', 'important');
    embed.style.setProperty('--forms-base-font-size', '16px', 'important');
    embed.style.setProperty('--forms-heading-font', 'normal 700 32px DM Sans, sans-serif', 'important');
    embed.style.setProperty('--forms-body-font', 'normal 400 16px DM Sans, sans-serif', 'important');
  }

  function addShadowStyles(embed) {
    if (!embed.shadowRoot || embed.shadowRoot.getElementById(styleId)) {
      return;
    }

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = shadowStyles;
    embed.shadowRoot.appendChild(style);
  }

  function addTermsLink(embed) {
    if (!embed.shadowRoot) {
      return;
    }

    const fieldset = embed.shadowRoot.querySelector('fieldset[name="custom#terms_agreement"]');
    const label = fieldset && fieldset.querySelector('label');

    if (!label || label.dataset.sukkerTermsLinked === 'true') {
      return;
    }

    const existingLink = label.querySelector('.sukker-terms-link');

    if (existingLink) {
      existingLink.replaceWith(document.createTextNode(existingLink.textContent));
      label.normalize();
    }

    const textNodes = [];
    const walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
    let textNode = walker.nextNode();

    while (textNode) {
      textNodes.push(textNode);
      textNode = walker.nextNode();
    }

    const text = textNodes.map((node) => node.textContent).join('');
    const termsMatch = text.match(/\bterms\s*&\s*conditions\b/i);

    if (!termsMatch) {
      return;
    }

    const termsIndex = termsMatch.index;
    const termsEndIndex = termsIndex + termsMatch[0].length;
    let currentIndex = 0;
    let startNode;
    let startOffset;
    let endNode;
    let endOffset;

    textNodes.forEach((node) => {
      const nodeEndIndex = currentIndex + node.textContent.length;

      if (!startNode && termsIndex >= currentIndex && termsIndex < nodeEndIndex) {
        startNode = node;
        startOffset = termsIndex - currentIndex;
      }

      if (!endNode && termsEndIndex > currentIndex && termsEndIndex <= nodeEndIndex) {
        endNode = node;
        endOffset = termsEndIndex - currentIndex;
      }

      currentIndex = nodeEndIndex;
    });

    if (!startNode || !endNode) {
      return;
    }

    const range = document.createRange();
    const link = document.createElement('a');

    link.href = termsUrl;
    link.target = '_blank';
    link.rel = 'noopener';
    link.className = 'sukker-terms-link';
    link.addEventListener('click', (event) => {
      event.stopPropagation();
    });

    range.setStart(startNode, startOffset);
    range.setEnd(endNode, endOffset);
    link.appendChild(range.extractContents());
    range.insertNode(link);
    label.dataset.sukkerTermsLinked = 'true';
  }

  function updateForms() {
    document.querySelectorAll('shopify-forms-embed').forEach((embed) => {
      setHostVariables(embed);
      addShadowStyles(embed);
      addTermsLink(embed);
    });
  }

  document.addEventListener('DOMContentLoaded', updateForms);
  window.addEventListener('load', updateForms);

  const observer = new MutationObserver(updateForms);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  let attempts = 0;
  const retry = window.setInterval(() => {
    attempts += 1;
    updateForms();

    if (attempts >= 40) {
      window.clearInterval(retry);
    }
  }, 250);
})();
